export type {
  FadeOptions,
  HighlightOptions,
} from '../internals/plugins/featurePlugins/useChartHighlight';
export type { HighlightScope } from '../models/seriesType/config';
export * from './useChartApiContext';
export type { ChartApi } from './ChartApi';
